import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHttp, useNotification } from 'src/hooks';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import IconSvg from 'src/components/common/ui/IconSvg';

export interface ForgetForm {
  email: string;
}

const ForgotPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const { sendRequest, isLoading, error } = useHttp();
  const notify = useNotification();

  const formik = useFormik<ForgetForm>({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email format').required('Email is required'),
    }),
    onSubmit: values => {
      sendRequest(
        {
          method: 'POST',
          url: `auth/generate-otp`,
          payload: { email: values.email },
        },
        () => {
          notify('Email dispatched! Please check your inbox.', 'success');
          navigate('/one-time-password', { state: { email: values.email } });
        },
      );
    },
  });

  const handleResend = () => {
    if (!formik.values.email) {
      notify('Please enter an email first.', 'error');
      return;
    }
    sendRequest(
      {
        method: 'POST',
        url: `auth/generate-otp`,
        payload: { email: formik.values.email },
      },
      () => {
        notify('Email resent! Please check your inbox.', 'success');
      },
    );
  };

  useEffect(() => {
    if (error) {
      notify(error || '', 'error');
    }
  }, [error]);

  return (
    <div className="lg:w-1/2 w-full lg:p-8 flex flex-col items-start">
      <IconSvg icon="appLogo" className="cursor-pointer lg:w-auto w-24" onClick={() => navigate('/')} alt="Logo" />

      <p className="lg:text-[36px] text-[28px] font-semibold text-black font-inter mt-8 lg:mb-6 mb-4">
        Forgot password
      </p>
      <p className="text-[#4A4D4F] lg:text-xl text-base font-normal font-inter mb-6">
        Let’s Help You Regain Your Access
      </p>
      <form className="w-full" onSubmit={formik.handleSubmit}>
        <div className="mb-4">
          <label className="block text-[#4A4D4F] lg:text-lg text-base font-normal mb-2">
            Email <span className="text-[#CC0E3C]">*</span>
          </label>
          <input
            type="email"
            name="email"
            placeholder="Enter email"
            className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 lg:text-base text-sm font-inter font-normal outline-none"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email && formik.errors.email && (
            <p className="text-red-500 text-sm mt-1">{formik.errors.email}</p>
          )}
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className={`w-full py-2 rounded text-white ${isLoading ? 'bg-gray-400 cursor-not-allowed opacity-50' : 'bg-blue-500'
            }`}
        >
          {isLoading ? 'Sending...' : 'Send'}
        </button>
      </form>

      {/* <div className="mt-4 flex items-center justify-center text-black w-full text-center lg:text-lg text-sm font-semibold">
        <p
          onClick={isLoading ? undefined : handleResend}
          className={`cursor-pointer underline underline-offset-4 ${
            isLoading ? "text-gray-400 cursor-not-allowed opacity-50" : "text-[#6277FF]"
          }`}
        >
          Resend
        </p>
      </div> */}
    </div>
  );
};

export default ForgotPasswordForm;
